import {RefObject} from 'react';

interface EnvelopeNameType {
  color?: string;
  font?: string;
}

interface EnvelopeType {
  closedFront?: string;
  name?: EnvelopeNameType;
}

interface StampType {
  image?: string;
}

interface EnvelopeStampSideProps {
  envelope?: EnvelopeType;
  stamp?: StampType;
  inviteName?: string;
  canvasRef: RefObject<HTMLCanvasElement | null>;
}

export const EnvelopeStampSide = ({
  envelope,
  stamp,
  inviteName,
  canvasRef,
}: EnvelopeStampSideProps) => (
  <div className="env-wrapper env-wrapper__stamp-side">
    <div className="env-group env-group__stamp-side">
      <img className="invite-envelope__full-width" src={envelope?.closedFront} alt="envelope" />
      <img
        className="invite-envelope__stamp"
        src={stamp?.image || '//g0.evitecdn.com/assets/stamp_image/1704926476/universal-stamp.png'}
        alt="envelope stamp"
      />
      <span
        style={{
          color: envelope?.name?.color,
          fontFamily: envelope?.name?.font,
        }}
        className="invite-envelope__guest-name"
      >
        {inviteName}
      </span>
      <div
        id="canvas__wrapper__stickers"
        className="invite-envelope__closed-front__wrapper__canvas"
      >
        <canvas ref={canvasRef} />
      </div>
    </div>
  </div>
);
